<template>

  <tr
    @click="$router.push(toRoute)"
    class="table-tr-pointer">
    <td class="text-truncate">
      <input 
        v-if="permissions.includes('manage_candidates')"
        type="checkbox" 
        :checked="selected.includes(candidate._id)" 
        :value="candidate._id" 
        @click="setCheck">
    </td>
    <td>
      <span
        @click="$event.stopPropagation()">
        <router-link
          :to="toRoute">
          <Avatar
            :src="imgSrc"
            :name="candidate.name"
            size="44px"
            radius="22px"
            resize="100x100x1" />
          </router-link>
      </span>
    </td>
    <td>
      <span
        @click="$event.stopPropagation()">
        <router-link
          style="color: inherit;"
          :to="toRoute">
          <span
            v-html="candidate.highlight.name"></span>
          <span
            class="badge badge-danger"
            v-if="candidate.placement.new">novo</span>
          </router-link>
      </span>

      <div
        class="subtext"
        v-if="subtitle"
        v-html="subtitle">
      </div>

      <ul
        class="list-tags mt-1"
        v-if="candidate.tags.length">
        <li
          v-for="(tag, index) in candidate.tags"
          :key="index">
          {{ tag }}
          </li>
      </ul>
    </td>
    <td>
      <div v-html="candidate.highlight.neighborhood"></div>
      <div v-html="candidate.highlight.city" class="subtext"></div>
      <div v-if="!candidate.highlight.neighborhood && !candidate.highlight.city">--</div>
    </td>
    <!--<td class="text-truncate">
      {{ candidate.salary ? $n(candidate.salary, {style: 'decimal', minimumFractionDigits: 2}) : '-' }}
    </td>-->
    <td class="text-truncate">
      <PercentEvaluation
        :value="candidate.avg_rating ? candidate.avg_rating.evaluation : null"
        empty="--"
        :icon="true" />
    </td>
    <td class="text-truncate">
      <PercentEvaluation
        :value="candidate.avg_rating ? candidate.avg_rating.questionnaire : null"
        empty="--" />
    </td>
    <td class="text-truncate">
      <PercentEvaluation
        :value="candidate.avg_rating ? candidate.avg_rating.intervideo : null"
        empty="--" />
    </td>
    <td class="text-truncate" v-if="resourceAvailability.features.includes('matcher')">
      <StarsScore
        v-if="candidate.placement.match_score"
        :value="candidate.placement.match_score" />
    </td>
    <td class="text-truncate">
      {{ candidate.created_at | moment('fromNow', $i18n.locale) }}
    </td>
    <td class="text-truncate">
      <div class="mb-2">
        <strong :class="isDisqualified?'text-danger':'text-dark'">
          <i class="fas fa-ban" v-if="isDisqualified" />
          {{ candidate.placement.stage_id.name }}
        </strong>
      </div>
      <!--<div class="progress">
        <div class="progress-bar bg-info" role="progressbar" :style="{width: progress + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>-->
    </td>
    <td class="text-truncate">
      <span v-if="candidate.next_event" class="text-info"><i class="far fa-calendar-alt" /></span>
      <span v-if="candidate.placement.referral_name" class="text-secondary"><i class="fas fa-hand-point-right" /></span>
    </td>
  </tr>

</template>

<script>
import config from '@/config'
import PercentEvaluation from '@/components/Parts/PercentEvaluation'
import moment from 'moment'
import Avatar from '@/components/Parts/Avatar'
import StarsScore from '@/components/Parts/StarsScore'

export default {
  name: 'JobGridItem',
  props: [
    'candidate',
    'keywords'
  ],
  components: {
    PercentEvaluation,
    Avatar,
    StarsScore
  },
  data () {
    return {
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    subtitle () {
      return [
        this.candidate.highlight.headline,
        this.candidate.birth_date ? this.$t('n_years', { age: moment().diff(moment(this.candidate.birth_date), 'years') }) : null
      ]
      .filter(v => v)
      .join(', ')
    },
    job () {
      return this.$store.getters.getJob
    },
    progress () {
      return this.job.stages.findIndex((v) => {
        return v._id === this.candidate.placement.stage_id._id
      }) / this.job.stages.length * 100
    },
    isDisqualified () {
      return this.candidate.placement.status === 'disqualified'
    },
    toRoute () {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: this.candidate._id,
          candidate_job_id: this.candidate.placement.job_id
        }
      }
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    /*
    setCheck
    */
    setCheck (event) {
      this.$store.dispatch('toggleCandidateSelected', event.target.value)
      event.stopPropagation()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress{
  height: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/Job/JobGrid/JobGridItem.vue